module.exports = __webpack_public_path__ + "img/Animales-SMARTSCAN.b1e13b62.png";